import { render } from "./AppStatCard.vue?vue&type=template&id=40d18de7"
import script from "./AppStatCard.vue?vue&type=script&lang=js"
export * from "./AppStatCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__